export class MemoryTokenStore {
    token = null;
    async getToken() {
        return this.token;
    }
    async setToken(token) {
        this.token = token;
    }
}
